import React from "react";
import { useEffect } from "react";
import { Redirect, Route, Switch, useHistory, useRouteMatch, useLocation } from "react-router-dom";
import Navbar from "../Components/navbar/Navbar";
import Sidebar from "../Components/navbar/Sidebar";
import UserTable from "../Components/table/UserTable";
import Dashboard from "./Dashboard";
import LiveStreams from "./LiveStreams";
import PanelVoiceRooms from "./Panel/VoiceRooms";
import PanelGames from "./Panel/Games";
import PanelPk from "./Panel/PkBattles";
import PanelMoney from "./Panel/MoneyLogs";
import PanelDuplicates from "./Panel/Duplicates";
import PanelCoinFlow from "./Panel/CoinFlow";
import PanelStore from "./Panel/StoreRings";
import PanelSocial from "./Panel/SocialAdmin";
import PanelSafety from "./Panel/SafetyLists";
import PanelEconomy from "./Panel/EconomySettings";
import PanelInbox from "./Panel/InboxAdmin";
import PanelBanners from "./Panel/Banners";
import PanelAgencies from "./Panel/Agencies";
import PanelAgencyTargets from "./Panel/AgencyTargets";
import PanelCoinBank from "./Panel/CoinBank";
import PanelAccounts from "./Panel/Accounts";
import PanelSalaryPolicy from "./Panel/SalaryPolicy";
import PanelVault from "./Panel/Vault";
import PanelAppVersion from "./Panel/AppVersion";
import PanelSplashAds from "./Panel/SplashAds";
import PanelOfficialRooms from "./Panel/OfficialRooms";
import PanelWebSite from "./Panel/WebSite";
import PanelContracts from "./Panel/Contracts";
import PanelCustomFrames from "./Panel/CustomFrames";
import PanelAutoPush from "./Panel/AutoPush";
import PanelAutoGreet from "./Panel/AutoGreet";
import PanelSvipGrant from "./Panel/SvipGrant";
import PanelLevelBadges from "./Panel/LevelBadges";
import PanelFaceVerify from "./Panel/FaceVerify";
import PanelPkTournament from "./Panel/PkTournament";
import PanelGuardian from "./Panel/Guardian";
import PanelBans from "./Panel/Bans";
import PanelVipMembers from "./Panel/VipMembers";
import PanelFanClub from "./Panel/FanClub";
import PanelTasks from "./Panel/Tasks";
import PanelMonthlyCard from "./Panel/MonthlyCard";
import PanelTranslate from "./Panel/Translate";
import PanelInvite from "./Panel/Invite";
import PanelBd from "./Panel/Bd";
import PanelMoments from "./Panel/Moments";
import PanelLevels from "./Panel/Levels";
import PanelStaff from "./Panel/Staff";
import PanelAyvoGames from "./Panel/AyvoGames";
import PanelAyvoLudoAgora from "./Panel/AyvoLudoAgora";
import PanelSendPackage from "./Panel/SendPackage";
import ComplaintQueue from "./ComplaintQueue";
import { BannedAccounts, BannedWords, AdminLogs } from "./Moderation";

//css
// import "../assets/js/bootstrap/css/bootstrap.min.css";
// import "../assets/css/plugins.css";
// import "../assets/css/structure.css";
import "../assets/css/tables/table-basic.css";
import "../assets/css/elements/search.css";
import "../assets/css/forms/switches.css";
import "../assets/css/elements/breadcrumb.css";
import "../assets/css/tables/table-basic.css";

//js
import "../assets/js/bootstrap/js/bootstrap.min.js";
import "../assets/js/bootstrap/js/popper.min.js";
import "../assets/js/app";

//component
import HostTable from "../Components/table/HostTable";
import HostRequest from "../Components/table/HostRequest";
import GiftCategory from "./GiftCategory";
import Gift from "./Gift";
import CoinPlanTable from "../Components/table/CoinPlanTable";
import Banner from "../Components/table/Banner";
import AddGift from "../Components/Dialog/Gift/AddGift";
import PendingComplaintTable from "../Components/table/PendingComplaintTable";
import SolvedComplaintTable from "../Components/table/SolvedComplaintTable";
import UserProflie from "./UserProflie";
import HostProflie from "./HostProflie";
import Proflie from "./Proflie";
import HostHistoryTable from "../Components/table/HostHistoryTable";
import UserHistory from "../Components/table/UserHistory";
import AppSetting from "./AppSetting";
import Error404 from "./Error404";
import Sticker from "../Components/table/Sticker";
import PendingRedeemTable from "../Components/table/PendingRedeemTable";
import DeclinedRedeem from "../Components/table/DeclinedRedeem";
import AcceptedRedeem from "../Components/table/AcceptedRedeem";
import PurchasePlanTable from "../Components/table/PurchasePlanTable";
import maleImg from "../assets/img/maleImage.png";
import $ from "jquery";
import Withdraw from "../Components/table/Withdraw";
import FakeHost from "../Components/table/FakeHost";
import FakeStory from "../Components/table/FakeStory.js";
import axios from "axios";
import { getProfile } from "../store/Admin/admin.action.js";
import { useDispatch } from "react-redux";

const Admin = () => {
  const dispatch = useDispatch()

  const token = sessionStorage.getItem("token");
  axios.defaults.headers.common["Authorization"] = token;

  const history = useHistory();
  const location = useRouteMatch();
  const routeNow = useLocation();

  // mobil menu: ust bardaki dugme acar, sayfa degisince / arka plana dokununca kapanir
  const [menuOpen, setMenuOpen] = React.useState(false);
  useEffect(() => {
    const toggle = () => setMenuOpen((v) => !v);
    window.addEventListener("badu:menu", toggle);
    return () => window.removeEventListener("badu:menu", toggle);
  }, []);
  useEffect(() => setMenuOpen(false), [routeNow.pathname]);
  useEffect(() => {
    document.body.classList.toggle("badu-drawer-open", menuOpen);
  }, [menuOpen]);

  useEffect(() => {
    if (history?.location?.pathname == "/admin/dashboard") {
      history?.push("/admin/dashboard");
    } // eslint-disable-next-line
  }, [history]);

  $(document).ready(function () {
    $("img").bind("error", function () {
      $(this).attr("src", maleImg);
    });
  });

  useEffect(() => {
    dispatch(getProfile())
  },[])
  return (
    <>
      <Navbar />

      {/* <SubNavbar /> */}

      <div
        class="main-container"
        id="container"
      >
        <div className="badu-scrim" onClick={() => setMenuOpen(false)}></div>
        <div className="search-overlay"></div>
        <Sidebar />
        <div id="content" class="main-content">
          <div class="layout-px-spacing mt-4">
            <Switch>
              <Route
                path={`${location?.path}/dashboard`}
                component={Dashboard}
              />
              <Route path={`${location?.path}/profile`} component={Proflie} />

              <Route
                path={`${location?.path}/user`}
                exact
                component={UserTable}
              />
              <Route
                path={`${location?.path}/fakeStory`}
                exact
                component={FakeStory}
              />
              <Route
                path={`${location?.path}/user/history`}
                exact
                component={UserHistory}
              />
              <Route
                path={`${location?.path}/user/userProfile`}
                component={UserProflie}
              />
              <Route
                path={`${location?.path}/host/hostProfile`}
                component={HostProflie}
              />
              <Route
                path={`${location?.path}/host`}
                exact
                component={HostTable}
              />
              <Route
                path={`${location?.path}/fakeHost`}
                exact
                component={FakeHost}
              />
              <Route
                path={`${location?.path}/sticker`}
                exact
                component={Sticker}
              />
              <Route
                path={`${location?.path}/host/history`}
                exact
                component={HostHistoryTable}
              />
              <Route
                path={`${location?.path}/hostRequest`}
                exact
                component={HostRequest}
              />
              <Route
                path={`${location?.path}/giftCategory`}
                exact
                component={GiftCategory}
              />
              <Route path={`${location?.path}/gift`} exact component={Gift} />
              <Route
                exact
                path={`${location?.path}/giftCategory/dialog`}
                component={AddGift}
              />

              <Route
                exact
                path={`${location?.path}/gift/dialog`}
                component={AddGift}
              />

              <Route
                path={`${location?.path}/coinPlan`}
                exact
                component={CoinPlanTable}
              />

              <Route
                path={`${location?.path}/withdraw`}
                exact
                component={Withdraw}
              />
              <Route
                path={`${location?.path}/purchasePlan`}
                exact
                component={PurchasePlanTable}
              />
              <Route
                path={`${location?.path}/banner`}
                exact
                component={PanelBanners}
              />
              {/* <Route
                path={`${location?.path}/setting`}
                exact
                component={Setting}
              /> */}
              <Route
                exact
                path={`${location?.path}/giftCategory/gift`}
                component={Gift}
              />
              <Route
                path={`${location?.path}/pendingRedeem`}
                exact
                component={PendingRedeemTable}
              />
              <Route
                path={`${location?.path}/acceptedRedeem`}
                exact
                component={AcceptedRedeem}
              />
              <Route
                path={`${location?.path}/declinedRedeem`}
                exact
                component={DeclinedRedeem}
              />
              <Route
                path={`${location?.path}/pendingComplaint`}
                exact
                component={PendingComplaintTable}
              />

              <Route
                path={`${location?.path}/solvedComplaint`}
                exact
                component={SolvedComplaintTable}
              />
              <Route
                path={`${location?.path}/appSetting`}
                exact
                component={AppSetting}
              />
              <Route path={`${location?.path}/liveStreams`} exact component={LiveStreams} />
              <Route path={`${location?.path}/complaintQueue`} exact component={ComplaintQueue} />
              <Route path={`${location?.path}/bannedAccounts`} exact component={BannedAccounts} />
              <Route path={`${location?.path}/bannedWords`} exact component={BannedWords} />
              <Route path={`${location?.path}/adminLogs`} exact component={AdminLogs} />
              <Route path={`${location?.path}/voiceRooms`} exact component={PanelVoiceRooms} />
              <Route path={`${location?.path}/games`} exact component={PanelGames} />
              <Route path={`${location?.path}/pkBattles`} exact component={PanelPk} />
              <Route path={`${location?.path}/moneyLogs`} exact component={PanelMoney} />
              <Route path={`${location?.path}/duplicates`} exact component={PanelDuplicates} />
              <Route path={`${location?.path}/coinFlow`} exact component={PanelCoinFlow} />
              {/* eski baglantilar */}
              <Route path={`${location?.path}/giftLogs`} exact render={() => <Redirect to={`${location?.path}/moneyLogs?tab=gifts`} />} />
              <Route path={`${location?.path}/purchases`} exact render={() => <Redirect to={`${location?.path}/moneyLogs?tab=purchases`} />} />
              <Route path={`${location?.path}/withdrawal`} exact render={() => <Redirect to={`${location?.path}/pendingRedeem`} />} />
              <Route path={`${location?.path}/complaints`} exact render={() => <Redirect to={`${location?.path}/pendingComplaint`} />} />
              <Route path={`${location?.path}/storeRings`} exact component={PanelStore} />
              <Route path={`${location?.path}/social`} exact component={PanelSocial} />
              <Route path={`${location?.path}/safety`} exact component={PanelSafety} />
              <Route path={`${location?.path}/economy`} exact component={PanelEconomy} />
              <Route path={`${location?.path}/inbox`} exact component={PanelInbox} />
              <Route path={`${location?.path}/agencies`} exact component={PanelAgencies} />
              <Route path={`${location?.path}/agencyTargets`} exact component={PanelAgencyTargets} />
              <Route path={`${location?.path}/coinBank`} exact component={PanelCoinBank} />
              <Route path={`${location?.path}/accounts`} exact component={PanelAccounts} />
              <Route path={`${location?.path}/salaryPolicy`} exact component={PanelSalaryPolicy} />
              <Route path={`${location?.path}/vault`} exact component={PanelVault} />
              <Route path={`${location?.path}/appVersion`} exact component={PanelAppVersion} />
              <Route path={`${location?.path}/splashAds`} exact component={PanelSplashAds} />
              <Route path={`${location?.path}/officialRooms`} exact component={PanelOfficialRooms} />
              <Route path={`${location?.path}/webSite`} exact component={PanelWebSite} />
              <Route path={`${location?.path}/contracts`} exact component={PanelContracts} />
              <Route path={`${location?.path}/customFrames`} exact component={PanelCustomFrames} />
              <Route path={`${location?.path}/autoPush`} exact component={PanelAutoPush} />
              <Route path={`${location?.path}/autoGreet`} exact component={PanelAutoGreet} />
              <Route path={`${location?.path}/svipGrant`} exact component={PanelSvipGrant} />
              <Route path={`${location?.path}/levelBadges`} exact component={PanelLevelBadges} />
              <Route path={`${location?.path}/faceVerify`} exact component={PanelFaceVerify} />
              <Route path={`${location?.path}/pkTournament`} exact component={PanelPkTournament} />
              <Route path={`${location?.path}/guardian`} exact component={PanelGuardian} />
              <Route path={`${location?.path}/bans`} exact component={PanelBans} />
              <Route path={`${location?.path}/vipMembers`} exact component={PanelVipMembers} />
              <Route path={`${location?.path}/fanClub`} exact component={PanelFanClub} />
              <Route path={`${location?.path}/tasks`} exact component={PanelTasks} />
              <Route path={`${location?.path}/monthlyCard`} exact component={PanelMonthlyCard} />
              <Route path={`${location?.path}/translate`} exact component={PanelTranslate} />
              <Route path={`${location?.path}/invite`} exact component={PanelInvite} />
              <Route path={`${location?.path}/bd`} exact component={PanelBd} />
              <Route path={`${location?.path}/moments`} exact component={PanelMoments} />
              <Route path={`${location?.path}/levels`} exact component={PanelLevels} />
              <Route path={`${location?.path}/staff`} exact component={PanelStaff} />
              <Route path={`${location?.path}/ayvoGames`} exact component={PanelAyvoGames} />
              <Route path={`${location?.path}/ayvoLudoAgora`} exact component={PanelAyvoLudoAgora} />
              <Route path={`${location?.path}/sendPackage`} exact component={PanelSendPackage} />
              <Route path={`${location?.path}/*`} exact component={Error404} />
            </Switch>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
